<template>
  <div class="api-pretext">BUY NOW</div>
  <div class="api__bg" v-if="Object.keys(dataModel[props.brandExperience].retailers).length > 0">
    
    <div class="api">
      <div
        v-for="item in dataModel[props.brandExperience].retailers"
        :key="item.retailer"
        class="api__retailer"
      >
        <a :href="item.url" class="api__a" target="_blank" data-action="csClickToRetailer">

          <div class="api__img-wrapper temp__center" data-action="csClickToRetailer">
            <img :src="item.logo" class="api__img--logo" data-action="csClickToRetailer" />
          </div>
          <div class="api__price" data-action="csClickToRetailer">£{{ item.price }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import dataModel from "../js/model.js";

const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
});
$(document).ready(function() {
  $('.api__price').css({
    backgroundColor: dataModel[props.brandExperience].ui.primaryColor
  });
  var widgetHeight = $('.api__bg').outerHeight();
  $('.api__bg').css({
    marginTop: -widgetHeight/2
  })
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.api-pretext {
  color: #ffffff;
  font-weight: 600;
  font-size: 20px;
  position: absolute;
  margin: auto;
  margin-top: -90px;
  z-index: 1000;
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
}
.api__bg {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  display: inline-block;
  max-width: 90%;
  min-width: none;
  overflow: scroll;
  position: relative;
  z-index: 150;
  
  @media screen and (max-width: 475px) {
    border-radius: 0px;
    bottom: 0px;
    left: 0px;
    margin-right: 10px;
    max-width: none;
    overflow: scroll;
    position: fixed;
    width: 100%;
    z-index: 150;
  }
}
.api {
  @include flexbox();
  @include align-items(center);
  @include justify-content(flex-start);
  padding: 10px;
  width: 100%;

  @media screen and (max-width: 475px) {
    @include justify-content(flex-start);
  }
}
.api__retailer {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  max-width: 100px;
  min-width: 70px;
  position: relative;
  &:not(:last-child) {
    margin-right: 10px;
  }
  &:last-child:after {
    content: "";
    position: absolute;
    height: 100%;
    right: -10px;
    top: 0;
    background: none;
    width: 20px;
  }  
}
.api__img-wrapper {
  padding: 5px;
}
.api__img--logo {
  display: block;
  width: 100%;
}
.api__a {
  color: #333333;
  text-decoration: none;
}
.api__price {
  border-radius: 0px 0px 5px 5px;
  color: #ffffff;
  font-size: 11px;
  font-weight: bold;
  padding: 5px 0px;
  text-align: center;
}
</style>